import { noCurrency } from 'helpers/utils';

export const terrainsByIdsAdapter = (data, products) => {
 const terrains = data?.terrains.filter(a => products.some(e => e === a._id)) || []; // Array de productos
 const allTerrains = data?.terrains || []; // Array de todos los productos
 console.log(data, 'los datos que llegan');

 const fnc = terrains.map(a => {
  const financing = data.financings.find(f => f.name === a.type) ?? data.financings[0];
  if (financing?.minInitialPay < 1) financing.minInitialPay = a.price * financing.minInitialPay;
  return financing;
 }) || [{ initialFee: 0, minFeeIni: 0, minFeeFnc: 0, maxInitials: 0, maxFinancing: 0, minInitialPay: 0 }];

 if (fnc.length === 0) fnc.push({ initialFee: 0, minFeeIni: 0, minFeeFnc: 0, maxInitials: 0, maxFinancing: 0, minInitialPay: 0 });

 const totals = terrains.reduce((a, b) => a + parseFloat(b.price), 0); // Total del valor de todos los productos
 const minFeeIni = fnc.reduce((a, b) => a + parseFloat(b.minFeeIni), 0); // Monto minimo de cada cuota de la inicial
 const minFeeFnc = fnc.reduce((a, b) => a + parseFloat(b.minFeeFnc), 0); // Monto minimo de cada cuota en la financiacion

 const iniPercentage = Math.max(...fnc.filter(r => r.initialFee >= 0).map(r => r.initialFee)); // Porcentage de la cuota inicial
 const fncPercentage = 1 - iniPercentage; // Porcentage de la financiacion
 const maxInitials = Math.max(...fnc.filter(r => r.maxInitials >= 0).map(r => r.maxInitials)); // Num de cuotas max en la inicial
 const maxFinancing = Math.max(...fnc.filter(r => r.maxFinancing >= 0).map(r => r.maxFinancing)); // Num de cuotas max en financiacion
 const minInitialPay = fnc.reduce((a, b) => a + parseFloat(b.minInitialPay), 0); // Monto de la separacion para apartar el producto

 const iniVal = totals * (iniPercentage ?? 0); // Monto de la cuota inicial
 const fncVal = totals - iniVal; // Monto de la financiacion

 return {
  fnc,
  totals,
  minFeeIni,
  minFeeFnc,
  iniPercentage,
  fncPercentage,
  iniVal,
  fncVal,
  maxInitials,
  maxFinancing,
  minInitialPay,
  terrains,
  allTerrains,
  project: { _id: data?._id, logo: data?.logo, name: data?.name },
  company: { ...(data?.company ?? {}), type: 'company' }
 };
};

const quotas = (quotas, type = 'INICIAL') => {
 const cuotasArray = [];

 // Obtén las claves que comienzan con 'fee-' (para el número de cuota)
 const feeKeys = Object.keys(quotas).filter(key => key.startsWith('fee-'));

 feeKeys.forEach(feeKey => {
  // Extrae el número de cuota desde la clave (por ejemplo, 'fee-1' -> 1)
  const fee = parseInt(feeKey.split('-')[1]);

  // Genera la clave correspondiente para la fecha
  const dateKey = `date-${fee}`;
  const amount = noCurrency(quotas[feeKey]);

  const cuota = {
   fee,
   type: type,
   amount,
   date: quotas[dateKey],
   days: 0,
   status: 'PENDIENTE',
   balance: amount,
   interest: 0.0,
   lastDate: quotas[dateKey]
  };

  cuotasArray.push(cuota);
 });

 return cuotasArray;
};

export const createAdapter = data => {
 const {
  date,
  company,
  receivers,
  customers,
  agent,
  business,
  executor,
  emitters,
  saving,
  minInitialPay,
  quotasInitial,
  quotasFinan,
  defaultValues: { totals, terrains, project }
 } = data;

 return {
  agent,
  company,
  project,
  business,
  executor,
  emitters,
  receivers,
  customers,
  params: data,
  type: 'ORDER',
  products: [...terrains],
  typeProducts: [...(terrains.length ? ['terrains'] : [])],
  amount: totals - saving,
  methods: [],
  financing: [
   {
    fee: 1,
    type: 'SEPARACION',
    amount: noCurrency(minInitialPay),
    date,
    days: 0,
    status: 'PENDIENTE',
    balance: noCurrency(minInitialPay),
    interest: 0.0,
    lastDate: date
   },
   ...quotas(quotasInitial, 'INICIAL'),
   ...quotas(quotasFinan, 'FINANCIACION')
  ]
 };
};
